import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import {
  FilesProvider,
  LocaleProvider,
  SnackbarProvider,
  NavigationProvider,
  UserProvider,
  LocaleName,
  InactivityProvider,
  FormAnchorProvider,
  ValidationProvider,
  WebsocketProvider,
  useEventCallback,
  PromptProvider,
} from '@eas/common-web';
import { AppPublic } from './app-public';
import { ThemeProvider } from './modules/theme/theme-provider';
import { AppSecure } from './app-secure';
import { Permission } from '@enums';
import { Me } from '@models';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

class ErrorBoundary extends React.Component {
  state = { error: null };

  render() {
    if (!this.state.error) {
      return this.props.children;
    } else {
      console.log(this.state.error);

      return (
        <div>
          <h1>Chyba aplikace</h1>
          <p>
            Kontaktujte podporu... zatím:{' '}
            <a href="https://trex-runner.com/">https://trex-runner.com/</a>
          </p>
          <p>{(this.state.error as any)?.toString()}</p>
        </div>
      );
    }
  }

  static getDerivedStateFromError(error: any) {
    return { error };
  }
}

const queryClient = new QueryClient();

export function App() {
  const checkPermission = useEventCallback((user: Me, permission: string) => {
    const isAdmin = user.authorities.find(
      (auth) => auth.authority === Permission.Default.ADMINISTRATOR
    );

    if (isAdmin) {
      return true;
    }

    return !!user.authorities.find((auth) => {
      const resolvedPermission = auth?.permission ?? auth.authority;

      return resolvedPermission === permission;
    });
  });
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <LocaleProvider defaultLocale={LocaleName.cs}>
            <ValidationProvider>
              <SnackbarProvider timeout={3000}>
                {/*  <AppSettingsProvider url="/api/tapis/app-settings"> */}
                <FilesProvider url="/api/tapis/files">
                  <UserProvider
                    meUrl="/api/tapis/me"
                    logoutUrl="/api/tapis/logout"
                    checkPermission={checkPermission}
                  >
                    <InactivityProvider timeout={3600}>
                      <FormAnchorProvider>
                        <PromptProvider>
                          <BrowserRouter>
                            <NavigationProvider>
                              <Switch>
                                <Route exact path="/login">
                                  <AppPublic />
                                </Route>
                                <Route path="/">
                                  <WebsocketProvider
                                    wsUrl="/api/tapis/stomp"
                                    destinations={[]}
                                    debug={false}
                                    requiredUser={false}
                                  >
                                    <AppSecure />
                                  </WebsocketProvider>
                                </Route>
                              </Switch>
                            </NavigationProvider>
                          </BrowserRouter>
                        </PromptProvider>
                      </FormAnchorProvider>
                    </InactivityProvider>
                  </UserProvider>
                </FilesProvider>
                {/*        </AppSettingsProvider> */}
              </SnackbarProvider>
            </ValidationProvider>
          </LocaleProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
